// Recovered from the preserved MetaCard production build.
// Behavior is retained; local names and TypeScript types were lost during minification.
import { postJson } from "./client.jsx";
export const fetchCollectionPage = (u, o, m = 10, r = !0, g = !1, j = "", B = "", U = null, N) => postJson("/api/collection", {
  initData: u,
  universe: o,
  limit: m,
  includeSummary: r,
  includeUniverseProgresses: g,
  query: j,
  rarity: B,
  cursor: U
}, N);
export const fetchCollectionSummary = (u, o, m) => postJson("/api/collection/summary", {
  initData: u,
  universe: o
}, m);
export const fetchCollectionUniverses = (u, o) => postJson("/api/collection/universes", {
  initData: u
}, o);
